import BaseApi from './BaseApi';
import store from '@/store';

class MessageApi extends BaseApi {
  public getMessages(channelId, params?) {
    return this.getOne(channelId, params);
  }

  public readAllMessages(channelId, params?) {
    return this.post(`/${channelId}/reset-unread`, params);
  }

  public sendMessage(channelId, params) {
    const data = new FormData();
    Object.keys(params).forEach((key) => {
      data.append(key, params[key]);
    });

    return this.post(`/${channelId}`, data);
  }

  public sendSuggestPlan(channelId, data) {
    return this.post(`/${channelId}/suggest-plan`, data);
  }

  public confirmSuggestPlan(channelId, data) {
    return this.post(`/${channelId}/confirm-suggest-plan`, data);
  }

  public deleteMessage(messageId) {
    return this.del(`/${messageId}/delete`, {});
  }

  public updateMessage(messageId, body) {
    const data = new FormData();
    Object.keys(body).forEach((key) => {
      if (!body[key]) {
        return;
      }
      data.append(key, body[key]);
    });

    return this.post(`/${messageId}/update`, data);
  }

  protected getSpecificApiPrefix(): string {
    return 'managers/messages';
  }
}

export default MessageApi;
